import {DESCRIPTION_LAYOUT_TYPE} from "./constants";


export const isHybridCarousel = (carouselItems) => {
  return carouselItems.some( item => item && item.layoutType === DESCRIPTION_LAYOUT_TYPE.BUTTON);
}
